import { useState } from 'react';
import { Button } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { ChangeLogDrawer } from './ChangeLogDrawer';
import type { ChangeLogSubject } from './changeLogTypes';

/**
 * "View change log" for a page header. Give it a `key` of the subject's id where the page is
 * reused across ids, so moving to another record closes the drawer.
 */
export const ChangeLogLink: React.FC<{ subject: ChangeLogSubject }> = ({ subject }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="link" icon={<HistoryOutlined />} onClick={() => setOpen(true)}>
        View change log
      </Button>
      <ChangeLogDrawer open={open} onClose={() => setOpen(false)} subject={subject} />
    </>
  );
};
